define( function() {
	return [];
} );



//////////////////
// WEBPACK FOOTER
// ../node_modules/jquery/src/var/arr.js
// module id = 12
// module chunks = 0 1